import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationsHe from 'components/common/locales/he/translation.json'
import translationsEn from 'components/common/locales/en/translation.json'

const fallbackLng = ['en'];
const availableLanguages = ['en', 'he'];

const resources = {
    en: {
        translation: translationsEn
    },
    he: {
        translation: translationsHe
    },
};

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng,
        debug: false,
        whitelist: availableLanguages,
        interpolation: {
            escapeValue: false,
        },
    })
export default i18n;